import { DependencyList, useCallback } from 'react';
import { useObserver } from '../../CodesThatsGottaGoSomewhereElse';
import { useResolve } from '../Container';
import { PopupManager } from '../popups/PopupManager';
import { AccountModel } from './AccountModel';
import { accountReadonlyPopup } from './AccountReadonlyPopup';

export const useDashboardVersion = () => {
    const account = useObserver(useResolve(AccountModel));
    return account.settings['dashboard.version'] || 'legacy';
};

export const useIsFreeOrTrial = () => {
    const account = useObserver(useResolve(AccountModel));
    return account.plan.name.includes('free') || account.plan.name.includes('trial');
};

export const useAccountGuardCallback = <T extends (...args: any[]) => any>(callback: T, deps: DependencyList) => {
    const account = useObserver(useResolve(AccountModel));
    const popups = useResolve(PopupManager);
    const onUpgrade = useCallback(() => popups.invoke(accountReadonlyPopup()), []);

    return useCallback((...args: Parameters<T>) => {
        if (account.plan.features.readonly) {
            onUpgrade();
        }
        else {
            callback(...args);
        }
    }, [account, onUpgrade, callback, ...deps]) as T;
};
